<template>
  <div class="container-fluid">
    <div class="text-left">
      <h3>
        <router-link to="/ferias">Férias</router-link>
        <!--  » <a @click.prevent="addAno()">Marcar Uma Semana</a> -->
      </h3>
    </div>
    <table>
      <tr>
        <td>Ano</td>
        <td>Funcionário</td>
        <td>Semana 1</td>
        <td>Semana 2</td>
        <td>Semana 3</td>
      </tr>
      <tr v-for="row in rows">
        <td>{{row.ano}}</td>
        <td>{{row.funcionario}}</td>
        <td>
          {{normalizeData(row.s1)}}
          <span v-if="row.s1===''" class="calendario">
            <button v-if="showCalendar===0" class="btn btn-primary" @click="showCalendar=row.ano+'_'+row.cod"><i class="glyphicon glyphicon-calendar"></i></button>
            <Calendario v-if="showCalendar===row.ano+'_'+row.cod" @pickWeek="setWeek" class="calendario"></Calendario>
          </span>
        </td>
        <td>
          {{normalizeData(row.s2)}}
          <span v-if="row.s1 !== '' && row.s2===''" class="calendario">
            <button v-if="showCalendar===0" class="btn btn-primary" @click="showCalendar=row.ano+'_'+row.cod"><i class="glyphicon glyphicon-calendar"></i></button>
            <Calendario v-if="showCalendar===row.ano+'_'+row.cod" @pickWeek="setWeek" class="calendario"></Calendario>
          </span>
        </td>
        <td>
          {{normalizeData(row.s3)}}
          <span v-if="row.s2 !== '' && row.s3 === ''" class="calendario">
            <button v-if="showCalendar===0" class="btn btn-primary" @click="showCalendar=row.ano+'_'+row.cod"><i class="glyphicon glyphicon-calendar"></i></button>
            <Calendario v-if="showCalendar===row.ano+'_'+row.cod" @pickWeek="setWeek" class="calendario"></Calendario>
          </span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import Calendario from './Calendar.vue'
export default {
  name: 'Ferias',
  components: {
    Calendario
  },
  data () {
    return {
      ok: true,
      showCalendar: 0,
      rows: []
    }
  },
  methods: {
    load (params = '') {
      const url = './api/php/getferias.php'
      this.$http.post(url, JSON.stringify(params)).then(
        function (response) {
          console.log(response)
          this.rows = response.body.rows
        },
        function (error) {
          console.log(error)
        }
      )
    },
    save (params) {
      const url = './api/php/getferias.php'
      this.$http.post(url, JSON.stringify(params)).then(
        function (response) {
          console.log(response.body)
          this.rows = response.body.rows
        },
        function (error) {
          console.log(error)
        }
      )
    },
    addAno () {
      this.save({crud: 'c', cod: this.$root.cod})
    },
    setWeek (aDay, zDay, week) {
      console.log('As férias serão entre ' + aDay + ' e ' + zDay)
      let codigo = this.showCalendar.toString().substring(5, 7)
      this.save({crud: 'u', cod: codigo, data: aDay})
      this.showCalendar = 0
    },
    normalizeData (data) {
      if (data) {
        return data.substring(6, 8) + '/' + data.substring(4, 6) + '/' + data.substring(0, 4)
      } else {
        return ''
      }
    }
  },
  created: function () {
    this.load()
  }
}
</script>

<style scoped>
  .container-fluid {
      max-width: 80vw;
      margin: auto;
  }
  table {
    font: 12px sans-serif;
    color: #333;
    border-collapse: collapse;
    outline: 2px solid #333;
    text-align: left;
    width: 100%;
  }
  table tr:not(.bg-danger):not(:first-child) {
    background: #fcfcfc;
  }
  table tr:not(.bg-danger):not(:first-child):nth-child(2n+1) {
    background: #f1f1f1;
  }
  table tr:first-child {
    background: #333;
    color: #fff;
    text-transform: uppercase;
  }
  table tr:hover{
    background: #333;
  }
  table tr td {
    padding: 5px;
  }
  table tr td small {
    color: #777;
  }
  a.glyphicon {
    text-decoration: none;
  }
  span.calendario {
    position: relative;
    z-index: 1;
  }
  .calendario {
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 100;
  }

</style>



// WEBPACK FOOTER //
// src/components/FerRel.vue